import { useTranslation } from "react-i18next";

import { saveLocale } from "@/utils/local-storage";
import { isValidLocale } from "@/i18n/utils";
import { Locale } from "@/i18n/types";

export function useLocale() {
  const { i18n } = useTranslation();

  const changeLocale = (newLocale: string) => {
    if (!isValidLocale(newLocale)) return;

    saveLocale(newLocale);
    i18n.changeLanguage(newLocale);
  };

  return [i18n.language as Locale, changeLocale] as const;
}
